
<script setup>

import logoUrl from 'url:../../images/logo.svg'

</script>

<template>

  <header class="px-6 sm:px-8" ref="header">
    
    <div class="sm:relative max-w-screen-xl mx-auto flex sm:justify-center py-4 sm:py-5 min-h-[76px]" :class="[ $slots.default ? 'justify-between' : 'justify-center' ]">

      <a href="https://www.biomerieux.com/" class="z-20 mt-4 sm:mt-0">

        <img class="w-[66px] h-[66px] -mb-[58px] transition-[height,width] duration-300 sm:w-[124px] sm:h-[124px] sm:-mb-[62px]" :src="logoUrl" alt="bioMérieux logo" />

      </a>

      <slot></slot>

    </div>

  </header>

</template>